import { render, staticRenderFns } from "./PaperDialogDetails.vue?vue&type=template&id=689bd7b4&scoped=true&"
import script from "./PaperDialogDetails.vue?vue&type=script&lang=ts&"
export * from "./PaperDialogDetails.vue?vue&type=script&lang=ts&"
import style0 from "./PaperDialogDetails.vue?vue&type=style&index=0&id=689bd7b4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689bd7b4",
  null
  
)

export default component.exports